export default "__VITE_ASSET__nl28vDhA__"